var Wording = new (class Wording extends AbstractModule {

  constructor() {
    super("Wording");
  }

  _initData(data) {
    if (data.texts['md'] || data.texts['replace']) Utils.error('A reserved key was used in Wording.js');
    this._autoInit({
      // Retro compatibility, can be removed after bot tree full implementation
      "email_not_valid"                         : [ data.texts.email_not_valid, '' ],
      "offline_email_content"                   : [ data.texts.offline_email_content, '' ],
      "offline_message_content"                 : [ data.texts.offline_message_content, '' ],
      "offline_object_content"                  : [ data.texts.offline_object_content, '' ],
      "offline_submit_another_content"          : [ data.texts.offline_submit_another_content, '' ],
      "offline_submit_thanks"                   : [ data.texts.offline_submit_thanks, '' ],
      "online_submit_content"                   : [ data.texts.online_submit_content, '' ],
      "ai_description"                          : [ data.texts.ai_description, '' ],
      "ai_generating"                           : [ data.texts.ai_generating, '' ],
      "ai_searching"                            : [ data.texts.ai_searching, '' ],
      "copy_link"                               : [ data.texts.copy_link, 'Copy link' ],
      "link_copied"                             : [ data.texts.link_copied, 'Link copied' ],
      "content_moderated"                       : [ data.texts.content_moderated, '' ],
      "content_moderated_reply"                 : [ data.texts.content_moderated_reply, '' ],
      "about_window_cta"                        : [ data.texts.about_window_cta, '' ],
      "about_window_desc"                       : [ data.texts.about_window_desc, '' ],
      "about_window_subtitle"                   : [ data.texts.about_window_subtitle, '' ],
      "about_window_title"                      : [ data.texts.about_window_title, '' ],
      "ask_chattranscript_msg"                  : [ data.texts.ask_chattranscript_msg, '' ],
      "ask_command_button"                      : [ data.texts.ask_command_button, '' ],
      "asking_for_videochat"                    : [ data.texts.asking_for_videochat,'' ],
      "at_text"                                 : [ data.texts.at_text, '' ],
      "auto_translated_in"                      : [ data.texts.auto_translated_in ],
      "back_to_chat"                            : [ data.texts.back_to_chat, '' ],
      "back_to_quit"                            : [ data.texts.back_to_quit ],
      "back"                                    : [ data.texts.back, '' ],
      "bot_email_button"                        : [ data.texts.bot_email_button, '' ],
      "bot_input_text"                          : [ data.texts.bot_input_text, '' ],
      "bot_live_start"                          : [ data.texts.bot_live_start, '' ],
      "bot_oops_text"                           : [ data.texts.bot_oops_text, '' ],
      "bot_start_button"                        : [ data.texts.bot_start_button, '' ],
      "bot_success_text"                        : [ data.texts.bot_success_text, '' ],
      "btn_sendtranscript"                      : [ data.texts.btn_sendtranscript, '' ],
      "busy_message"                            : [ data.texts.busy_message, ''],
      "button_value_no"                         : [ data.texts.no_button_value, '' ],
      "button_value_yes"                        : [ data.texts.yes_button_value, '' ],
      "cancel_text"                             : [ data.texts.cancel_text ],
      "close_button"                            : [ data.texts.close_button, '' ],
      "close_chatbox"                           : [ data.texts.close_chatbox, '' ],
      "closed_conversation_short_text"          : [ data.texts.closed_conversation_short_text, '' ],
      "closed_conversation_text"                : [ data.texts.closed_conversation_text, '' ],
      "colon"                                   : [ data.texts.colon, '' ],
      "confirm_text"                            : [ data.texts.confirm_text, '' ],
      "conversation_about_text"                 : [ data.texts.conversation_about, '' ],
      "conversations_text"                      : [ data.texts.conversations, '' ],
      "email_asking_content_with_email"         : [ data.texts.email_asking_content_with_email, '' ],
      "email_asking_content"                    : [ data.texts.email_asking_content, '' ],
      "email_placeholder_content"               : [ data.texts.email_placeholder_content, '' ],
      "email_submit_content"                    : [ data.texts.email_submit_content, '' ],
      "email_text"                              : [ data.texts.email_text, '' ],
      "emojis_activities"                       : [ data.texts.emojis_activities ],
      "emojis_animals"                          : [ data.texts.emojis_animals ],
      "emojis_flags"                            : [ data.texts.emojis_flags ],
      "emojis_food"                             : [ data.texts.emojis_food ],
      "emojis_frequently_used"                  : [ data.texts.emojis_frequently_used ],
      "emojis_objects"                          : [ data.texts.emojis_objects ],
      "emojis_people"                           : [ data.texts.emojis_people ],
      "emojis_smileys"                          : [ data.texts.emojis_smileys ],
      "emojis_symbols"                          : [ data.texts.emojis_symbols ],
      "emojis_travel"                           : [ data.texts.emojis_travel ],
      "faq_try_again"                           : [ data.texts.faq_try_again, '' ],
      "final_plural_connector"                  : [ data.texts.final_plural_connector, '' ],
      "final_singular_connector"                : [ data.texts.final_singular_connector, '' ],
      "full_name_text"                          : [ data.texts.full_name_text, '' ],
      "get_started"                             : [ data.texts.get_started, '' ],
      "go_back_to_call"                         : [ data.texts.go_back_to_call, '' ],
      "greeting_message"                        : [ data.texts.online_greetings, '' ],
      "group_asking_title"                      : [ data.texts.group_asking_title, '' ],
      "homepage_conversation_previous"          : [ data.texts.homepage_conversation_previous, '' ],
      "homepage_conversation_start"             : [ data.texts.homepage_conversation_start, '' ],
      "homepage_conversation_yours"             : [ data.texts.homepage_conversation_yours, '' ],
      "homepage_helpcenter_last_update"         : [ data.texts.homepage_helpcenter_last_update, '' ],
      "homepage_helpcenter_more"                : [ data.texts.homepage_helpcenter_more, '' ],
      "homepage_helpcenter_no_results"          : [ data.texts.homepage_helpcenter_no_results, '' ],
      "homepage_helpcenter_placeholder"         : [ data.texts.homepage_helpcenter_placeholder, '' ],
      "homepage_helpcenter_results"             : [ data.texts.homepage_helpcenter_results, '' ],
      "homepage_helpcenter_title"               : [ data.texts.homepage_helpcenter_title, '' ],
      "homepage_meetings_desc"                  : [ data.texts.homepage_meetings_desc, '' ],
      "homepage_meetings_title"                 : [ data.texts.homepage_meetings_title, '' ],
      "homepage_newsletter_fail"                : [ data.texts.homepage_newsletter_fail, '' ],
      "homepage_newsletter_success"             : [ data.texts.homepage_newsletter_success, '' ],
      "homepage_newsletter_title"               : [ data.texts.homepage_newsletter_title, '' ],
      "homepage_no_results_try_again"           : [ data.texts.homepage_helpcenter_no_results_try_again, '' ],
      "homepage_phone_desc"                     : [ data.texts.homepage_phone_desc, '' ],
      "homepage_phone_title"                    : [ data.texts.homepage_phone_title, '' ],
      "homepage_status_desc"                    : [ data.texts.homepage_status_desc, '' ],
      "homepage_status_title"                   : [ data.texts.homepage_status_title, '' ],
      "homepage_subtitle"                       : [ data.texts.homepage_subtitle, '' ],
      "in_weeks"                                : [ data.texts.in_weeks ],
      "invite_text"                             : [ data.texts.invite, '' ],
      "languages"                               : [ data.texts.languages ],
      "list_closed_conversations"               : [ data.texts.list_closed_conversations],
      "list_open_conversations"                 : [ data.texts.list_open_conversations],
      "loading_button_value"                    : [ data.texts.loading_button_value, '' ],
      "message_delivered_seen_text"             : [ data.texts.message_delivered_seen_text, '' ],
      "message_delivered_text"                  : [ data.texts.message_delivered_text, '' ],
      "message_from"                            : [ data.texts.message_from, '' ],
      "message_sending_text"                    : [ data.texts.message_sending_text, '' ],
      "minutes_text"                            : [ data.texts.minutes_text, '' ],
      "name_placeholder_content"                : [ data.texts.name_placeholder_content, '' ],
      "name_text"                               : [ data.texts.name_text, '' ],
      "new_conversation_text"                   : [ data.texts.new_conversation, '' ],
      "new_ephemeral_conversation_text"         : [ data.texts.new_ephemeral_conversation, '' ],
      "new_ephemeral_conversation_text_hint"    : [ data.texts.new_ephemeral_conversation_hint, '' ],
      "new_ephemeral_conversation_confirmation" : [ data.texts.new_ephemeral_conversation_confirmation, '' ],
      "next_week"                               : [ data.texts.next_week ],
      "offline_greeting_message"                : [ data.texts.offline_greetings, '' ],
      "offline_submit_content"                  : [ data.texts.offline_submit_content, '' ],
      "online_input_content"                    : [ data.texts.online_input_content, '' ],
      "online_users_text"                       : [ data.texts.online_users, '' ],
      "open_chatbox"                            : [ data.texts.open_chatbox, '' ],
      "open_conversation"                       : [ data.texts.open_conversation, '' ],
      "phone_text"                              : [ data.texts.phone_text, '' ],
      "prechat_questions_final_message"         : [ data.texts.prechat_questions_final_message, '' ],
      "read_more"                               : [ data.texts.read_more, '' ],
      "reconnect"                               : [ data.texts.reconnect, '' ],
      "reconnecting_1"                          : [ data.texts.reconnecting_1, '' ],
      "reconnecting_2"                          : [ data.texts.reconnecting_2, '' ],
      "reopened_conversation_text"              : [ data.texts.reopened_conversation_text, '' ],
      "reply_from"                              : [ data.texts.reply_from, '' ],
      "request_chattranscript"                  : [ data.texts.request_chattranscript, '' ],
      "request_screensharing"                   : [ data.texts.request_screensharing, '' ],
      "request_videochat"                       : [ data.texts.request_videochat, '' ],
      "reschedule_text"                         : [ data.texts.reschedule_text, '' ],
      "schedule_a"                              : [ data.texts.schedule_a, '' ],
      "screenshot_question_declined"            : [ data.texts.screenshot_question_declined, '' ],
      "screenshot_question"                     : [ data.texts.screenshot_question, '' ],
      "screenshot_user_not_triggered"           : [ data.texts.screenshot_user_not_triggered, '' ],
      "screenshot_user_triggered"               : [ data.texts.screenshot_user_triggered, '' ],
      "searching_someone_to_answer"             : [ data.texts.searching_someone_to_answer, ''],
      "send_file"                               : [ data.texts.send_file ],
      "send_message"                            : [ data.texts.send_message ],
      "send_screenshot"                         : [ data.texts.send_screenshot, '' ],
      "show_more_dates"                         : [ data.texts.show_more_dates ],
      "show_more_times"                         : [ data.texts.show_more_times ],
      "show_original"                           : [ data.texts.show_original ],
      "show_translated"                         : [ data.texts.show_translated ],
      "snoozed_conversation_short_text"         : [ data.texts.snoozed_conversation_short_text, '' ],
      "survey_end_text"                         : [ data.texts.survey_end_text, '' ],
      "switch_to_offline_slaask_email"          : [ data.texts.switch_to_offline_slaask_email, '' ],
      "switch_to_offline_slaask_faq"            : [ data.texts.switch_to_offline_slaask_faq, '' ],
      "switch_to_offline_slaask"                : [ data.texts.switch_to_offline_slaask, '' ],
      "switch_to_offline_xeno_with_email"       : [ data.texts.switch_to_offline_xeno_with_email, '' ],
      "switch_to_offline_xeno"                  : [ data.texts.switch_to_offline_xeno, '' ],
      "switch_to_pending_with_email"            : [ data.texts.switch_to_pending_with_email, '' ],
      "switch_to_pending"                       : [ data.texts.switch_to_pending, '' ],
      "this_link_text"                          : [ data.texts.this_link, '' ],
      "this_week"                               : [ data.texts.this_week ],
      "time_day"                                : [ data.texts.time_day ],
      "time_days"                               : [ data.texts.time_days ],
      "time_hour"                               : [ data.texts.time_hour ],
      "time_hours"                              : [ data.texts.time_hours ],
      "time_minute"                             : [ data.texts.time_minute ],
      "time_minutes"                            : [ data.texts.time_minutes ],
      "time_month"                              : [ data.texts.time_month ],
      "time_months"                             : [ data.texts.time_months ],
      "time_prefix"                             : [ data.texts.time_prefix ],
      "time_seconds"                            : [ data.texts.time_seconds ],
      "time_suffix"                             : [ data.texts.time_suffix ],
      "time_year"                               : [ data.texts.time_year ],
      "title_changing_text"                     : [ data.texts.title_changing_text, '' ],
      "transcript_sent_feedback"                : [ data.texts.transcript_sent_feedback, '' ],
      "uploading_screenshot"                    : [ data.texts.uploading_screenshot, '' ],
      "uploading"                               : [ data.texts.uploading, '' ],
      "video_chat_with"                         : [ data.texts.video_chat_with ],
      "window_title"                            : [ data.texts.window_title, '' ],
      "with"                                    : [ data.texts.with ],
      "wording_and"                             : [ data.texts.wording_and, '' ],
      "you"                                     : [ data.texts.you ]
    });
  }

  replace(word, replaces) {
    let translation = this[word];
    Utils.forEach(replaces, (value, i) => {
      translation = translation.replace("%{" + i + "}", value);
    });
    return translation;
  }

  md(word, replaces = {}) {
    return this.app._askTechParser.mdToHtml(this.replace(word, replaces));
  }

});
